class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/* OohFound reliability fix: all storefront search forms submit once, on click or Enter. */
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const input = form.querySelector('input[type="search"][name="q"]');
  if (!input) return;

  const term = input.value.trim();
  if (!term) {
    event.preventDefault();
    input.focus();
    return;
  }

  const action = form.getAttribute('action') || '';
  if (!action.includes('/search')) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const url = new URL(action, window.location.origin);
  url.searchParams.set('q', term);
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[prefix]', 'last');
  window.location.assign(url.toString());
}, true);
